import { useBreakpoints } from "@/hooks/useBreakpoints";
import classNames from "classnames";
import { FC, ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface CardHeaderProps {
  className?: string;
  titleClassName?: string;
  title: string;
  endEl?: ReactNode;
}

const CardHeader: FC<CardHeaderProps> = ({
  title,
  className,
  titleClassName,
  endEl,
}) => {
  const { breakpoints } = useBreakpoints();

  return (
    <Card.Header
      className={classNames(
        "pb-2",
        {
          "d-flex justify-content-between align-items-center flex-wrap gap-2":
            !!endEl,
        },
        className
      )}
    >
      <h6
        className={classNames(
          {
            "mb-0": !breakpoints,
            [`mb-${breakpoints}-0`]: !!breakpoints,
          },
          titleClassName
        )}
      >
        {title}
      </h6>
      {endEl}
    </Card.Header>
  );
};

export default CardHeader;
